<template>
	<div class="cont_box">
		<div class="gall_box bai_box">
			<div class="gall_mbx">
				<el-breadcrumb separator=">">
					<el-breadcrumb-item>当前位置</el-breadcrumb-item>
					<el-breadcrumb-item>{{copyData.noticeTitle}}</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<div class="gall_cont">
				<div class="gall_title">
					{{copyData.noticeTitle}}
				</div>
				<div class="gall_boxs" v-html="copyData.noticeContent">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import headers from '@/components/header';
	import foot from '@/components/foot';
	export default {
		name: "UserDialong",
		data() {
			return {
				not_flag: true,
				tab_index: 'bqgg',
				currentPage3: 5,
				copyData: '', // 版本公告
			}
		},
		
		computed: {
			table() {
				
				this.$http.get('/front/notice/copyright').then(res => {
					
					console.log(res.data)
					this.copyData = res.data
				})
			},
		},
		
		mounted() {
			this.init()
		},
		methods: {
			init() {
				
				this.$http.get('/front/notice/copyright').then(res => {
					console.log("1234")
					console.log(res.data)
					this.copyData = res.data
				})
			},
			dec_btn() {
				this.$router.push({
					path: 'gallery_describe'
				})
			}
		},
		components: {
			headers,
			foot,
		}
	}
</script>

<style lang="less" scoped>
	.gall_box {
		//width: 870px;
		width: 1200px;
		margin: 0 auto;

		.gall_mbx {
			margin: 0 0 30px;
			padding: 37px 23px 0;

			span {
				font-size: 13px;
			}
		}

		.gall_slt {
			display: flex;
			justify-content: flex-end;
			align-items: center;
			cursor: pointer;

			.icon {
				width: 20px;
				height: 20px;
				margin-right: 15px;
			}

			span {
				font-size: 15px;
				color: #22AB67;
			}
		}

		.gall_fy {
			margin: 30px 0 60px;

			.block {
				display: flex;
				justify-content: center;
			}
		}

		.gall_cont {
			padding: 0 36px 30px;
			margin-bottom: 62px;

			.gall_title {
				font-weight: bold;
				font-size: 23px;
				color: #000000;
				text-align: center;
				margin-bottom: 31px;
			}

			.gall_p {
				color: #333333;
				font-size: 14px;
				margin-bottom: 46px;
				line-height: 1.5;
			}

			.gall_boxs {
				color: #4A4A4A;
				line-height: 2;
				margin-bottom: 50px;
			}
		}

		.gall_times {
			text-align: right;
			color: #676767;
			font-size: 13px;
		}
	}
</style>
